<ui-drawer
  [open]="true"
  placement="center"
  [title]="title() + ' · ' + subtitle()"
  [mobileTitle]="subtitle()"
  [showSaveButton]="false"
  [fill]="true"
  panelWidth="72vw"
  panelHeight="80dvh"
  (closed)="closed.emit()"
>
  <div class="ui-video-playlist-dialog__viewer">
    <div class="ui-video-playlist-dialog__playlist" role="list">
      @for (item of clips(); track item.title) {
        @if (item.title !== activeClip().title) {
        <button
          type="button"
          class="ui-video-playlist-dialog__playlist-item"
          (click)="clipSelect.emit(item)"
        >
          <span class="ui-video-playlist-dialog__playlist-thumb">
            <video
              [src]="item.src"
              muted
              preload="metadata"
              playsinline
              (loadedmetadata)="onProgressThumbReady($event)"
            ></video>
          </span>
          <span class="ui-video-playlist-dialog__playlist-label">
            {{ item.title }}
          </span>
        </button>
        }
      }
    </div>

    <div class="ui-video-playlist-dialog__player-wrap">
      <video
        class="ui-video-playlist-dialog__player"
        [src]="activeClip().src"
        controls
        autoplay
        playsinline
      ></video>
    </div>
    <p class="ui-video-playlist-dialog__now">
      {{ title() }} · {{ activeClip().title }}
    </p>
  </div>
</ui-drawer>
